import React from 'react'
import styled from 'styled-components'
import { MainButton } from '@appearance/styled'

const MainButtons = ({ btnsArr }) => {
    const buttonComponents = btnsArr.map(function (button, i) {
        return (
            <Button key={i} onClick={button.onClick} bgColor={button.bgColor}>
                <div
                    style={{
                        display: 'inline-flex',
                        flexDirection: 'row-reverse',
                        direction: 'rtl',
                    }}>
                    {button.label}
                    {button.icon && (
                        <img
                            src={button.icon}
                            style={{
                                margin: '3px 5px',
                                width: '20px',
                                height: '20px',
                            }}
                            alt={'img-alt' + i}
                        />
                    )}
                </div>
                <span> {button.span}</span>
            </Button>
        )
    })

    return <Wrap>{buttonComponents}</Wrap>
}

export default MainButtons

const Button = styled(MainButton)`
    background-color: ${(p) => p.bgColor};
    margin: 0px 8px;
`

const Wrap = styled.div`
    display: flex;
`
